import SecondaryLabel from '@/views/components/Labels/SecondaryLabel';
import ScrollPagination from '@/views/components/Paginations/ScrollPagination';
import { Button, Col, Row } from 'antd';
import React from 'react';

const SaversHomeGrid = ({ trailerRequestCt, errMessage, handleNextPage, columns }) => {
  return (
    <Row gutter={15}>
      <Col sm={24}>
        <div className="savers">
          <ScrollPagination
            className="br-4 w-100 scrollable-table-container horizontal"
            scrollOffset={50}
            hideSpinner
            loadMore={handleNextPage}
            disabledForceNextPage
          >
            <table className="w-100 br-4">
              <thead>
                <tr>
                  {columns.map(
                    ({ text, hidden }) =>
                      !hidden && (
                        <th key={text} className="background-header text-white fixed fixed-top fixed-left">
                          {text}
                        </th>
                      ),
                  )}
                </tr>
              </thead>
              <tbody>
                {trailerRequestCt.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length} style={{ textAlign: 'center', color: 'red' }}>
                      {errMessage}
                    </td>
                  </tr>
                ) : (
                  trailerRequestCt.map((row) => (
                    <tr key={row.trailerRequestID}>
                      <GenerateColumnValues row={row} columns={columns} />
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </ScrollPagination>
        </div>
      </Col>
    </Row>
  );
};

const GenerateColumnValues = React.memo(({ row, columns }) => {
  return (
    <>
      {columns.map(
        ({ dataField, formatter, hidden, align, events }) =>
          !hidden && (
            <td key={dataField} className={`text-${align || 'left'}`}>
              <SecondaryLabel className="f-15 fw-600 text-black">
                {events?.onClick ? (
                  <Button type="button" onClick={(e) => events.onClick(e, null, null, row, null)}>
                    {formatter ? formatter(row[dataField], row) : row[dataField]}
                  </Button>
                ) : formatter ? (
                  formatter(row[dataField], row)
                ) : (
                  row[dataField]
                )}
              </SecondaryLabel>
            </td>
          ),
      )}
    </>
  );
});

export default SaversHomeGrid;
